import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { mini, theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import messages from './messages';
import styles from './styles.module.scss';

const mapStateToProps = combineSelectors({
  mini,
  theme,
});

export const iconContainerStyle = ({ theme }) => ({
  background: theme.palette.secondary,
});

export const headerContainerStyle = ({ theme }) => ({
  background: theme.palette.primary,
});

export const announcementBrand = ({ mini }) =>
  mini ? styles.announcementMini : styles.announcement;

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['importantAnnouncement', 'viewButton'],
  }),
  connect(mapStateToProps),
  addProps({
    iconContainerStyle,
    headerContainerStyle,
    announcementBrand,
  }),
);
